"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roleHash = void 0;

var _ethers = require("ethers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ethers = _objectSpread({}, _ethers.ethers);

if (ethers.version.startsWith("6.")) {
  ethers.utils = {
    id: ethers.id
  };
  ethers.constants = {
    HashZero: ethers.ZeroHash
  };
}

const roleHash = {
  DefaultAdmin: ethers.constants.HashZero,
  MinterRole: ethers.utils.id("MINTER_ROLE"),
  AccepterRole: ethers.utils.id("ACCEPTER_ROLE"),
  RestorerRole: ethers.utils.id("RESTORER_ROLE"),
  MinterAdminRole: ethers.utils.id("MINTER_ADMIN_ROLE"),
  AccepterAdminRole: ethers.utils.id("ACCEPTER_ADMIN_ROLE"),
  RestorerAdminRole: ethers.utils.id("RESTORER_ADMIN_ROLE")
};
exports.roleHash = roleHash;